import React, {Component} from 'react'
import AmCharts from "@amcharts/amcharts3-react";

class LineChart extends Component {

    constructor(props) {
        super(props);

    }

    componentDidMount() {

    }
    componentWillUnmount() {
        // clearInterval(this.state.timer);
    }
    handleClick(e){
        console.log(e);
    }
    render() {   //console.log(this.props.data);
        var categoryCount = (this.props.data || []).length;
        var graphs = [];
        var valueAxes = [];
        var l =1;
        var fileName = ''
        if(this.props.name===null || this.props.name==='null' || this.props.name===undefined || this.props.name==='undefined') {
          fileName = "chartData"
        }
        fileName = this.props.name;
        var barColors = ["#2196f3","#3366cc","#dc3912","#ff9900","#109618","#990099","#0099c6","#dd4477","#66aa00","#b82e2e","#316395","#3366cc","#994499","#22aa99","#aaaa11","#6633cc","#e67300","#8b0707","#651067","#329262","#5574a6","#3b3eac","#b77322","#16d620","#b91383","#f4359e","#9c5935","#a9c413","#2a778d","#668d1c","#bea413","#0c5922","#743411"]
        var pos = "left";
        this.props.y_axis.map(function (pl, index) {
            if(l>1) { pos = "right"; }
            if(pl=='Transaction Volume') {
                graphs.push({
                    "balloonText": pl+":[[value]]",
                    "title": pl,
                    "type": "column",
                    "fillAlphas": 0.8,
                    "lineAlpha": 0.2,
                    "valueField": pl,
                    "valueAxis": "v"+l,
                    "fillColors":barColors[index],
                });
                valueAxes.push({
                    "id":"v"+l,
                    "axisThickness": 2,
                    "position": pos,
                    "axisColor": "#E3E3E3",
                    "title": pl,
                    "axisAlpha": 1,
                    // "titleBold": false,
                    "titleColor": "#333333",
                    "titleFontSize": 11
                })
            }
            else {
                graphs.push({
                    "valueAxis": "v"+l,
                    "bullet": "round",
                    "bulletBorderAlpha": 1,
                    "bulletColor": "#FFFFFF",
                    "bulletSize": 3,
                    // "balloon": {
                    //     "enabled": true,
                    //     "horizontalPadding":2
                    // },
                    "hideBulletsCount": 50,
                    "lineThickness": 2,
                    "balloonText": "<span style='font-size:9px; color:#000000;'>[[title]]: [[value]]</br>[[lableText]]</span>",
                    "title": pl,
                    "useLineColorForBulletBorder": true,
                    "valueField": pl,
                    "color": "#000000"

                });
                valueAxes.push({
                    "id":"v"+l,
                    "axisThickness": 2,
                    "position": pos,
                    "axisColor": "#E3E3E3",
                    "title": pl,
                    "axisAlpha": 1,
                    // "titleBold": false,
                    "titleColor": "#333333",
                    "titleFontSize": 11
                })
            }

            l++;
        })

        const config = {
            "type": "serial",
            // Relative width so columns shrink to fit the card instead of overlapping
            "columnWidth": 0.7,
            "columnSpacing": "100",
            "theme": "default",
            "legend": {
                "useGraphSettings": true,
                // "verticalGap":4,
                "valueFunction": function(graphDataItem, valueText) {
                    return "";
                },
                "align": "center",
                "autoMargins": false,
                "equalWidths": false,
                "valueAlign": "left",
                "valueWidth": 10,
                "markerSize": 10,
                "fontSize":8,
                "marginLeft":0,
                "marginRight":0,
                "marginTop":0,
                "marginBottom":0,
                "verticalGap":5

            },
            "marginTop": 5,
            "marginRight": 10,
            "marginLeft": 20,
            "autoMarginOffset": 20,
            "mouseWheelZoomEnabled": true,
            "dataProvider": this.props.data,
            "synchronizeGrid":true,
            "valueAxes": valueAxes,
            "graphs": graphs,
            "chartScrollbar": {
                "enabled":false,
                "graph": "g1",
                "autoHide": true,
                "oppositeAxis": false,
                "offset":30,
                "scrollbarHeight": 80,
                "backgroundAlpha": 0,
                "selectedBackgroundAlpha": 0.1,
                "selectedBackgroundColor": "#888888",
                "graphFillAlpha": 0,
                "graphLineAlpha": 0.5,
                "selectedGraphFillAlpha": 0,
                "selectedGraphLineAlpha": 1,
                "autoGridCount": true,
                "color":"#AAAAAA"
            },
            "chartCursor": {
                "pan": true,
                "valueLineEnabled": true,
                "valueLineBalloonEnabled": true,
                "cursorAlpha":1,
                "cursorColor":"#258cbb",
                "limitToGraph":"g1",
                "valueLineAlpha":0.2,
                "valueZoomable": true,
                "zoomable": true
            },
            "valueScrollbar":{
                "enabled" :false,
                "oppositeAxis": false,
                "offset":50,
                "scrollbarHeight":10
            },
            "categoryField": this.props.x_axis,
            "categoryAxis": {
                "dashLength": 1,
                "minorGridEnabled": false,
                "gridPosition": "start",
                // Label every category (e.g. every date) instead of amCharts' auto-skipped subset
                "autoGridCount": false,
                "gridCount": categoryCount,
                "labelRotation": categoryCount > 12 ? 90 : 25,
                "fontSize":8,
            },
            "export": {
                "enabled": true,
                "fileName": fileName.replace(/ /g,"_"),
                "menu": [ {
                "class": "export-main",
                "menu": ["XLSX", "CSV" ],
              } ]
            },
            listeners:[{
                "event": "clickGraphItem",
                "method": (e)=>{this.handleClick(e.item)}
            }]
        };
        return (
            <div className ="chart_div">
                <AmCharts.React style={{ width: "100%", height: this.props.chartHeight }} options={config} />
            </div>
        );
    }
}

export default LineChart;